import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daf8kl1tto0ceqqnh80g";

type Status = "idle" | "loading" | "success" | "error";

function NewsletterForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = String(data.get("website_alt") || "").trim();
    setFormError("");

    if (honeypot) {
      form.reset();
      setStatus("success");
      return;
    }
    data.delete("website_alt");

    setStatus("loading");
    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = parsed?.meta as Record<string, unknown> | undefined;
      const message = meta?.message || parsed?.message || meta?.detail || responseText;
      const code = parsed?.code;
      const isSpam = /spam/i.test(String(message || ""));

      if (res.ok && code === "OK" && !isSpam) {
        form.reset();
        setStatus("success");
      } else {
        setStatus("error");
        setFormError(String(message || "订阅失败，请稍后再试"));
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后再试");
    }
  }

  return (
    <section className="rounded-2xl bg-primary-600 px-6 py-8 text-background-50 md:px-10 md:py-12" aria-label="订阅每日早报">
      <div className="mx-auto grid max-w-3xl items-center gap-6 md:grid-cols-2">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold">
            <i className="ri-mail-send-line" />
            免费订阅 · 随时退订
          </span>
          <h3 className="mt-3 font-heading text-2xl font-bold leading-snug md:text-3xl">
            订阅每日早报，<br className="hidden sm:block" />
            不错过任何要闻
          </h3>
          <p className="mt-2 text-sm text-background-50/80">
            每天早上八点，把昨夜今晨的重点资讯整理好送到你的邮箱。
          </p>
        </div>

        <div>
          <form
            id="newsletter-subscribe-form"
            data-readdy-form="daf8kl1tto0ceqqnh80g"
            onSubmit={handleSubmit}
            noValidate
          >
            <div className="flex flex-col gap-2 rounded-lg bg-background-50 p-2 sm:flex-row sm:items-center sm:rounded-full">
              <div className="flex flex-1 items-center gap-2 px-3">
                <i className="ri-mail-line text-foreground-400" />
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="请输入邮箱地址"
                  aria-label="邮箱地址"
                  className="w-full bg-transparent py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <button
                type="submit"
                disabled={status === "loading"}
                className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-70"
              >
                {status === "loading" ? "提交中…" : "立即订阅"}
              </button>
            </div>
            {/* 反垃圾蜜罐字段 */}
            <label className="contact-website">
              网站地址
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </label>
            <p className="mt-2 text-xs text-background-50/70" aria-live="polite">
              {status === "success" && "订阅成功，欢迎加入，每天早晨见！"}
              {status === "error" && formError}
              {status !== "success" && status !== "error" && "我们不会向第三方共享你的邮箱。"}
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}

export default NewsletterForm;